const REGISTER_URL = process.env.REACT_APP_FORM_URL?.replace(
  '/consultation',
  '/source/register',
);

export async function registerSource(
  accessToken: string,
  lineId: string,
  keyword: string,
  displayName?: string,
  pictureUrl?: string,
): Promise<{
  source: { name: string; keyword: string };
  updated: boolean;
  action: 'new' | 'overwrite' | 'unchanged';
  previousSource: { keyword: string; name: string | null } | null;
  hasProfile: boolean;
}> {
  if (!REGISTER_URL) throw new Error('連線資料有誤');
  const res = await fetch(`${REGISTER_URL}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: accessToken,
    },
    body: JSON.stringify({ keyword, lineId, displayName, pictureUrl }),
  });
  if (!res.ok) {
    if (res.status === 404) throw new Error('連結無效');
    if (res.status === 401) throw new Error('驗證失敗');
    throw new Error('註冊失敗');
  }
  return res.json();
}
